class InfiniteScroll {
  constructor() {
    this.container = document.getElementById('ProductGridContainer');
    this.grid = document.getElementById('product-grid');

    if (!this.container || !this.grid) return;

    this.nextUrl = this.container.dataset.nextUrl;
    this.loading = false;

    // Trigger when user is 400px before grid bottom
    this.threshold = 400;

    this.bindScroll();

    // Auto-load if grid is shorter than viewport
    setTimeout(() => {
      if (this.getGridBottom() <= window.innerHeight) {
        this.loadMore();
      }
    }, 300);
  }

  bindScroll() {
    this.scrollHandler = () => {
      if (this.loading || !this.nextUrl) return;

      const scrollBottom =
        window.scrollY + window.innerHeight;

      const gridBottom = this.getGridBottom();

      if (scrollBottom >= gridBottom - this.threshold) {
        this.loadMore();
      }
    };

    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  getGridBottom() {
    const rect = this.grid.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  }

  async loadMore() {
    if (!this.nextUrl || this.loading) return;

    this.loading = true;

    try {
      const response = await fetch(this.nextUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newProducts = html.querySelectorAll('#product-grid > *');
      const newNextUrl =
        html.querySelector('#ProductGridContainer')?.dataset.nextUrl;

      newProducts.forEach(product => {
        this.grid.appendChild(product);
      });

      this.nextUrl = newNextUrl || null;
      this.container.dataset.nextUrl = this.nextUrl;

      if (!this.nextUrl) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      this.loading = false;
    }
  }

  destroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  }
}

function initInfiniteScroll() {
  if (window.infiniteScrollInstance) {
    window.infiniteScrollInstance.destroy();
  }

  window.infiniteScrollInstance = new InfiniteScroll();
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);

// REQUIRED for Dawn filters & sorting
document.addEventListener('shopify:section:load', initInfiniteScroll);
